var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaterialmanagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_311_1542",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 26,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1.00033H26.6667V26.667H1V1.00033Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_311_1542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.29346 25.915H23.637C24.8828 25.915 25.8928 24.9051 25.8928 23.6592V11.5277C25.8928 10.2818 24.8828 9.27181 23.637 9.27181H16.813",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3094 22.9072H23.637C24.8829 22.9072 25.8928 21.8973 25.8928 20.6514",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8052 18.3955C13.8052 15.9037 11.7852 13.8838 9.29346 13.8838C6.80173 13.8838 4.78174 15.9037 4.78174 18.3955C4.78174 20.8873 6.80173 22.9072 9.29346 22.9072C11.7852 22.9072 13.8052 20.8873 13.8052 18.3955Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.813 18.3955V9.27181C16.813 5.11887 13.4464 1.75228 9.29346 1.75228C5.14057 1.75228 1.77393 5.11887 1.77393 9.27181V18.3955",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.813 18.3955C16.813 14.2426 13.4464 10.876 9.29346 10.876C5.14057 10.876 1.77393 14.2426 1.77393 18.3955C1.77393 22.5484 5.14057 25.915 9.29346 25.915C13.4464 25.915 16.813 22.5484 16.813 18.3955Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7974 18.3955C10.7974 17.565 10.1241 16.8916 9.29346 16.8916C8.4629 16.8916 7.78955 17.565 7.78955 18.3955C7.78955 19.2261 8.4629 19.8994 9.29346 19.8994C10.1241 19.8994 10.7974 19.2261 10.7974 18.3955Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialmanagement);
export default __webpack_public_path__ + "static/media/Materialmanagement.5fb958a716eef5b3efbd4b630fa92372.svg";
export { ForwardRef as ReactComponent };